import { CERTIFICATE_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import {
  ICertificatesDocumentUploadPostBody,
  ICertificatesDocumentUploadPostResponse,
} from "@/api_framework/api_modals/Certificates";
import { setDocumentUpload } from "@/app_redux/reducers/slices/auth/certificate_slice";

type ICartAPIResponse = { status: boolean; message: string };

AxiosCurlirize(axios, () => {});
export const useDocumentUploadAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterParams: ICertificatesDocumentUploadPostBody) => {
      dispatch(
        setLoading({
          key: "isEMRCreateInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(CERTIFICATE_MODULE?.DOCUMENT_UPLOAD?.baseURL, filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICertificatesDocumentUploadPostResponse>) => {
            dispatch(
              setLoading({
                key: "isEMRCreateInProgress",
                status: false,
              }),
            );
            const isSuccess = res?.data?.status === true || String(res?.data?.status).toLowerCase() === "true";
            if (isSuccess) {
              toast.success("Document uploaded successfully");
              return { status: true, message: "" };
            } else {
              dispatch(setDocumentUpload(null));
              return { status: false, message: res?.data?.message || "Failed to upload document." };
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config?.["curlCommand"]);
            dispatch(
              setLoading({
                key: "isEMRCreateInProgress",
                status: false,
              }),
            );
            dispatch(setDocumentUpload(null));
            const errorMessage =
              (e?.response?.data as any)?.message || (e?.response?.data as any)?.detail || "Failed to upload document.";
            return { status: false, message: errorMessage };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
